import { IDictionary } from "./dictionary";

export const filterDictionary: IDictionary = {
    contest: "Concurso",
    year: "Ano",
    status: "Status"
};
